const getSalePackageOptions = (packages, currentValue = "") => {
  const names = packages
    .filter((item) => item.IsActive === "Active" && typeof item.name === "string")
    .map((item) => item.name);
  // Historical orders and in-progress selections must survive catalog changes.
  if (currentValue) names.push(currentValue);
  return Array.from(new Set(names)).sort((a, b) => a.localeCompare(b));
};

module.exports = { getSalePackageOptions };
